export const isAdmin = window.location
.pathname.startsWith("/admin")
